import { render } from "./Imprint.vue?vue&type=template&id=23af5972&scoped=true&ts=true"
import script from "./Imprint.vue?vue&type=script&lang=ts"
export * from "./Imprint.vue?vue&type=script&lang=ts"

import "./Imprint.vue?vue&type=style&index=0&id=23af5972&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23af5972"]])

export default __exports__